import { createClient } from '@infuse/api/common';

const client = createClient('/rest/features');

export const getFeatures = async function (): Promise<string[]> {
  try {
    const response = await client.get<string[]>('');
    return response.data;
  } catch (error: any) {
    return [];
  }
};
